// src/components/AdminLayout.js
import React from 'react';
import { Box, Toolbar } from '@mui/material';
import Navbar from './Navbar';
import { Outlet } from 'react-router-dom';

export default function AdminLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Top navbar only */}
      <Navbar />

      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: theme => theme.spacing(8), // leave space for AppBar height
          backgroundColor: theme => theme.palette.background.default,
        }}
      >
        {/* This will render the routed page */}
        <Outlet />
      </Box>
    </Box>
  );
}
